module.exports = __webpack_public_path__ + "img/kommune-1445.8a32df94.svg";